export default "<div ng-bind-html=\"wysiwygCtrl.config.content | nl2br | a2nt | videoUrlToIframe\" class=\"readonly\"></div>\n";